/* src/tutors/cards/SettingsCard/index.js */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { withStyles } from '@material-ui/core/styles';
import { Modal, Paper, Typography } from '@material-ui/core';

import { HeaderTable, SimpleTable, TabBar } from '../../../../app/components';
import styles from './styles';

import {
  getCourses,
  getNumApproved,
  getPolicies,
  getLocations,
  getSchedules,
} from '../../selectors';
import { loadTexts } from '../../../../config/texts';

// const multibookLessonsPolicy = [
//   { title: 'Tier 1', value: '5 Lessons, 10% Off' },
//   { title: 'Tier 2', value: '10 Lessons, 15% Off' },
//   { title: 'Tier 3', value: '15 Lessons, 20% Off' },
// ];
const TEXT_KEY = 'tutors';

class SettingsCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      open: props.open,
      texts: loadTexts(TEXT_KEY, props.locale)
    };

    this._handleChange = this._handleChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ open: nextProps.open });
  }

  _handleChange(event, value) {
    this.setState({ value });
  }

  render() {
    const {
      classes,
      onClose,
      name,
      courses,
      numApproved,
      policies,
      locations,
      schedules,
    } = this.props;
    const { value, open, texts: { setting } } = this.state;

    return (
      <Modal
        aria-labelledby="Tutor Settings"
        aria-describedby="Also shows visual indicator whether a tutor set proper settings"
        open={open}
        onClose={onClose}
      >
        <Paper className={classes.paper}>
          <div className={classes.header}>
            <Typography variant="headline">{name}</Typography>
            <Typography>{`${setting.available} ${numApproved}/${courses.length} ${setting.courses}`}</Typography>
          </div>
          <TabBar
            value={value}
            onChange={this._handleChange}
            fullWidth
            labels={[
              setting.labels.policies,
              setting.labels.courses,
              setting.labels.schedule,
              setting.labels.locations
            ]}
          />
          {value === 0 && (
            <React.Fragment>
              <SimpleTable
                data={policies.studentRestrictionPolicy}
                header={this.state.texts.header.student_restriction}
                gutterBottom
              />
              <SimpleTable
                data={policies.cancelationPolicy}
                header={this.state.texts.header.cancellation_policy}
                gutterBottom
              />
              {/* <SimpleTable data={multibookLessonsPolicy}
              header="Multi-Book Lessons Policy" /> */}
            </React.Fragment>
          )}
          {value === 1 && (
            <HeaderTable data={courses} />
          )}
          {value === 2 && (
            <HeaderTable data={schedules} />
          )}
          {value === 3 && (
            <HeaderTable data={locations} />
          )}
        </Paper>
      </Modal>
    );
  }
}

SettingsCard.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  courses: PropTypes.array.isRequired,
  numApproved: PropTypes.number.isRequired,
  policies: PropTypes.object.isRequired,
  locations: PropTypes.array.isRequired,
  schedules: PropTypes.array.isRequired,
};

const mapStateToProps = state => ({
  courses: getCourses(state),
  numApproved: getNumApproved(state),
  policies: getPolicies(state),
  locations: getLocations(state),
  schedules: getSchedules(state),
  locale: state.appState.locale,
});

export default compose(
  withStyles(styles, { name: 'SettingsCard' }),
  connect(mapStateToProps)
)(SettingsCard);



// WEBPACK FOOTER //
// ./src/modules/tutors/cards/SettingsCard/index.js